/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { Box, FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { TAGS } from 'modules/transactions/constants';
import { selectVisualFilters } from 'modules/scenario/selectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSubBreakdownFilter } from 'modules/transactions/components/inner-filter/functions';

const BreakdownFilter = ({ value, onChange }) => {
  const [chartBreakdownList, setChartBreakdownList] = useState([]);
  const visualFilters = useSelector(selectVisualFilters);
  // Current selected breakdown
  const [chartBreakdown, setChartBreakdown] = useState(value ?? null);

  const handleBreakdownChange = (event) => {
    const selected = event.target.value;
    setChartBreakdown(selected);
    onChange?.(selected); // Notify parent
  };

  // Triggered when visualFilters value changes
  useEffect(() => {
    const subBreakdownFilter = getSubBreakdownFilter(visualFilters, TAGS.TREND);
    if (subBreakdownFilter) {
      setChartBreakdownList(subBreakdownFilter);
    }
  }, [visualFilters]);
  return (
    <Box sx={{ display: 'flex', gap: 3, flexDirection: 'column', pl: 1 }}>
      <RadioGroup value={chartBreakdown ?? ''} onChange={handleBreakdownChange}>
        {chartBreakdownList
          ?.sort((a, b) => a.label.localeCompare(b.label))
          .map((item) => (
            <FormControlLabel
              key={item?.id}
              value={item?.label}
              control={<Radio />}
              label={item?.label}
              sx={{ my: -0.5 }}
            />
          ))}
      </RadioGroup>
    </Box>
  );
};

export default BreakdownFilter;
